/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datenotset2Inputs */

const en_datenotset2 = /** @type {(inputs: Datenotset2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date not set`)
};

const de_datenotset2 = /** @type {(inputs: Datenotset2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum noch nicht festgelegt`)
};

/**
* | output |
* | --- |
* | "Date not set" |
*
* @param {Datenotset2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const datenotset2 = /** @type {((inputs?: Datenotset2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datenotset2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_datenotset2(inputs)
	return de_datenotset2(inputs)
});
export { datenotset2 as "dateNotSet" }